import React, { useContext } from "react";
import styled, { css } from "styled-components";
import FormDataContext from "integrations/contexts/FormDataContext";
import useFetch from "integrations/hooks/useFetch";
import Store from "logic/local-storage/Store";
import { StatusIcon } from "components/common";
import urlWithEventHubParams from "enterprise-integrations/helpers/urlWithEventHubParams";
import { ApiRoutes } from "./common/Routes";
import { toAWSSecurityLakeInputCreateRequest } from "./common/formDataAdapter";
import FormWrap from "../common/FormWrap";
const Container = styled.div(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.variant.darkest.default};
    margin: 25px 0;
    padding: 15px;
    border-radius: 4px;
    width: max-content;
  `
);
const Subheader = styled.h3`
  margin: 0 0 10px;
`;
const ReviewItems = styled.ul(
  ({ theme }) => css`
    list-style: none;
    margin: 0 0 25px 10px;
    padding: 0;

    li {
      line-height: 2;
      padding: 0 5px;

      &:nth-of-type(odd) {
        background-color: ${theme.colors.table.row.backgroundStriped};
      }
    }

    strong::after {
      content: ':';
      margin-right: 5px;
    }
  `
);
const StepReview = ({ onSubmit, externalInputSubmit = false }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const { formData } = useContext(FormDataContext);
  const throttleEnabled = !!((_a = formData.awsSecurityLakeThrottleEnabled) == null ? void 0 : _a.value);
  const storeFullMessage = !!((_b = formData.awsSecurityLakeStoreFullMessage) == null ? void 0 : _b.value);
  const [saveInput, setSaveInput] = useFetch(
    null,
    (result) => {
      if (result == null ? void 0 : result.id) {
        Store.sessionSet("setup_wizard_input_id", result.id);
      }
      onSubmit();
    },
    "POST",
    toAWSSecurityLakeInputCreateRequest(formData),
    urlWithEventHubParams
  );
  const formError = saveInput.error ? {
    full_message: saveInput.error,
    nice_message: /* @__PURE__ */ React.createElement("span", null, "We were unable to save your Input, please try again in a few moments.")
  } : null;
  const handleSubmit = () => {
    if (externalInputSubmit) {
      onSubmit(formData);
      return;
    }
    setSaveInput(ApiRoutes.INTEGRATIONS.AWSSecurityLake.SAVE_INPUT);
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: "Save and Start Input",
      loading: saveInput.loading,
      error: formError,
      description: "Check out everything below to make sure it's correct, then click the button below to complete your AWS Security Lake setup!"
    },
    /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Subheader, null, "Input Configuration"), /* @__PURE__ */ React.createElement(ReviewItems, null, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Name"), /* @__PURE__ */ React.createElement("span", null, formData.awsSecurityLakeName.value)), ((_c = formData.awsAccessKey) == null ? void 0 : _c.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS Access Key ID: "), /* @__PURE__ */ React.createElement("span", null, (_d = formData.awsAccessKey) == null ? void 0 : _d.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Subscriber Region"), /* @__PURE__ */ React.createElement("span", null, formData.securityLakeRegion.value)), ((_e = formData.assumeRoleArn) == null ? void 0 : _e.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS Assume Role (ARN): "), /* @__PURE__ */ React.createElement("span", null, (_f = formData.assumeRoleArn) == null ? void 0 : _f.value)), ((_g = formData.awsExternalId) == null ? void 0 : _g.value) && /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "AWS External ID: "), /* @__PURE__ */ React.createElement("span", null, (_h = formData.awsExternalId) == null ? void 0 : _h.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Polling Interval"), /* @__PURE__ */ React.createElement("span", null, formData.pollingInterval.value)), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Enable Throttling"), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: throttleEnabled }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "Store Full Message"), /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StatusIcon, { active: storeFullMessage }))), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("strong", null, "SQS Message Batch Size "), /* @__PURE__ */ React.createElement("span", null, (_i = formData.sqsMessageBatchSize) == null ? void 0 : _i.value))))
  );
};
export default StepReview;
